import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Button, Stack, Rating, FormControlLabel, Checkbox, Alert } from "@mui/material";
import ApiInstance from "../api/ApiInstance";

// Uitkomstmeting (DPIA-annex 01-gdpr/uitkomstmeting-annex.md): stille kaart op
// het cliënt-dashboard na elke 3e verrichte sessie. Twee eigen 1-5-vragen,
// expliciete opt-in bij de eerste keer, "liever niet" is definitief. De
// psycholoog ziet de antwoorden nooit; werkgevers alleen k>=10-gemiddelden.
export default function OutcomeCard() {
  const { t } = useTranslation();
  const [state, setState] = useState<{ eligible: boolean; consentAsked: boolean } | null>(null);
  const [progress, setProgress] = useState<number | null>(null);
  const [usefulness, setUsefulness] = useState<number | null>(null);
  const [consent, setConsent] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    ApiInstance.getApi().get("/outcome/prompt").then((r) => setState(r.data)).catch(() => setState(null));
  }, []);

  if (!state?.eligible || done) return null;
  const needsConsent = !state.consentAsked;

  const submit = async () => {
    setErr("");
    try {
      await ApiInstance.getApi().post("/outcome", { progress, usefulness, ...(needsConsent ? { consent: true } : {}) });
      setDone(true);
    } catch { setErr(t("outcome.error")); }
  };
  const decline = async () => {
    try { await ApiInstance.getApi().post("/outcome", { declineConsent: true }); } catch { /* stil */ }
    setDone(true);
  };

  return (
    <Box sx={{ p: 2.5, mb: 3, borderRadius: "var(--radius-lg)", bgcolor: "var(--primary-50)", border: "1px solid var(--primary-100)" }}>
      <Typography sx={{ fontWeight: 600, mb: 0.5 }}>{t("outcome.title")}</Typography>
      <Typography sx={{ fontSize: ".88rem", color: "text.secondary", mb: 2 }}>{t("outcome.privacyNote")}</Typography>
      <Stack spacing={1.5}>
        <Box>
          <Typography sx={{ fontSize: ".95rem", mb: 0.5 }}>{t("outcome.q1")}</Typography>
          <Rating value={progress} onChange={(_e: unknown, v: number | null) => setProgress(v)} max={5} />
        </Box>
        <Box>
          <Typography sx={{ fontSize: ".95rem", mb: 0.5 }}>{t("outcome.q2")}</Typography>
          <Rating value={usefulness} onChange={(_e: unknown, v: number | null) => setUsefulness(v)} max={5} />
        </Box>
        {needsConsent && (
          <FormControlLabel control={<Checkbox checked={consent} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConsent(e.target.checked)} />}
            label={<Typography sx={{ fontSize: ".88rem" }}>{t("outcome.consent")}</Typography>} />
        )}
        {err && <Alert severity="error" onClose={() => setErr("")}>{err}</Alert>}
        <Stack direction="row" spacing={1.5}>
          <Button size="small" variant="contained" onClick={submit} disabled={!progress || !usefulness || (needsConsent && !consent)}>{t("outcome.submit")}</Button>
          <Button size="small" variant="text" onClick={decline} sx={{ color: "text.secondary" }}>{t("outcome.decline")}</Button>
        </Stack>
      </Stack>
    </Box>
  );
}
